import { FieldBase } from '@shared/components/dynamic-form/models/field-base';

export class FieldTextarea extends FieldBase<string> {
  override controlType = 'textarea';
}
